/**
 * Loads deferred section scripts/styles when a section nears the viewport.
 * Looks for: script[type="text/cc-section-lazy"][data-src]
 *            link[data-cc-section-lazy][data-href]
 */
(function () {
  function activate(root) {
    if (!root || root.getAttribute('data-cc-lazy-loaded') === '1') return;
    root.setAttribute('data-cc-lazy-loaded', '1');

    root.querySelectorAll('script[type="text/cc-section-lazy"][data-src]').forEach(function (node) {
      var s = document.createElement('script');
      s.src = node.getAttribute('data-src');
      s.defer = true;
      document.body.appendChild(s);
      node.remove();
    });

    root.querySelectorAll('link[data-cc-section-lazy][data-href]').forEach(function (node) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = node.getAttribute('data-href');
      document.head.appendChild(link);
      node.remove();
    });

    // Reveal lazy images inside the section
    root.querySelectorAll('img[data-cc-lazy-src]').forEach(function (img) {
      img.src = img.getAttribute('data-cc-lazy-src');
      img.removeAttribute('data-cc-lazy-src');
      if (img.getAttribute('data-cc-lazy-srcset')) {
        img.srcset = img.getAttribute('data-cc-lazy-srcset');
        img.removeAttribute('data-cc-lazy-srcset');
      }
    });
  }

  function nearOrPast(el) {
    var rect = el.getBoundingClientRect();
    // In view, within preload margin, or already scrolled past (instant jump to footer).
    return rect.top < window.innerHeight + 250;
  }

  function watch(el) {
    if (!el) return;
    if (nearOrPast(el)) {
      activate(el);
      return;
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting || nearOrPast(entry.target)) {
              activate(entry.target);
              io.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '250px 0px' }
      );
      io.observe(el);
    } else {
      activate(el);
    }
  }

  function init() {
    document.querySelectorAll('[data-cc-lazy-section]').forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
